export class Contact {
    FirstName = '';
    LastName = '';
    Email = '';
    Company = '';
    Country = null;
    Product = null;
    Message = '';
    PhoneNumber = null;
}